import React from 'react';
import { trustStrip } from '../../data/site';
export function TrustStrip() {
  return <section aria-label="Format, delivery and payment" className="border-y border-gold/15 bg-forest text-white" data-id="element-265" data-mp="2sld70nosxmyh">
      <ul className="mx-auto grid max-w-page grid-cols-2 border-x border-white/10 lg:grid-cols-4" data-id="element-266" data-mp="2xkq37z1kc6dq">
        {trustStrip.map((item, index) => <li key={item.label} className={`flex flex-col items-center justify-center px-3 py-7 text-center sm:py-9 ${index % 2 === 1 ? 'border-l border-white/10' : ''} ${index > 1 ? 'border-t border-white/10 lg:border-t-0' : ''} ${index === 2 ? 'lg:border-l' : ''}`} data-id="element-267" data-mp="31kgqhsrvs4di" data-mpi={index}>
            <span className="font-display text-[34px] font-bold uppercase leading-none text-gold sm:text-[46px]" data-id="element-268" data-mp="3laanqmdd7bp4">
              {item.value}
            </span>
            <span className="mt-2 text-[12px] font-bold uppercase tracking-[0.14em] text-white/80 sm:text-[13px]" data-id="element-269" data-mp="3pdyvp65ws9aw">
              {item.label}
            </span>
          </li>)}
      </ul>
    </section>;
}